'use client';

import {
  Loader2,
  type AppIconProps,
} from '@/components/icons/app-icons';

import { cn } from '@/lib/ui/utils';

function Spinner({ className, ...props }: AppIconProps) {
  return (
    <Loader2
      role="status"
      aria-label="Loading..."
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
